import { FormsRegisterStaticField } from './forms-register-static-field';
import { StaticFieldIds } from './static-field-ids.enum';

export class FormsRegisterWorkflowStepField extends FormsRegisterStaticField {
  public readonly id = StaticFieldIds.WorkflowStep;
  public content: string;

  constructor({ form, template }: any) {
    super({ form, template });
    const column = template?.columns[form.isInColumn - 1];
    this.content = column?.title || '';
  }
}
